// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'element-ui/lib/theme-chalk/index.css'
// import 'c3/c3.min.css'
import locale from 'element-ui/lib/locale/lang/bg'

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import VueAuth from '@websanova/vue-auth'
import ElementUI from 'element-ui'
import format from 'date-fns/format'
import routes from './routes'
import App from './App'
// import consts from '../../server/consts'
import consts from './consts'

import common from './common'

const baseURL = '/api/' //process.env.NODE_ENV === 'development' ? 'http://localhost:3030/api/' : '/api/'

Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(ElementUI, {locale, size: 'medium'})
Vue.prototype.consts = consts
Vue.prototype.common = common
Vue.prototype.$baseURL = baseURL

Vue.axios.defaults.baseURL = baseURL
Vue.axios.defaults.responseType = 'json'
Vue.axios.defaults.headers.Accept = 'application/json'

// console.log(Vue.prototype.$http)
Vue.filter('formatPrice', common.formatPrice)
Vue.mixin({
  methods: {
    modelDate (value) {
      if (!value) {
        return null
      }
      const d = format(value, 'YYYY-MM-DD')
      return d && d !== 'Invalid Date' ? d : null
    }
  }
})

const router = Vue.router = new VueRouter({
  routes,
  mode: 'history',
  linkActiveClass: 'active'
})

Vue.use(VueAuth, {
  tokenName: 'token',
  fetchData: {url: '/auth/user', redirect: '/'},
  loginData: {url: '/auth/login'},
  refreshData: {enabled: false},
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js')
})

/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  render: h => h(App)
})
